export default async function initSourcebuster() {
  const sbjs = await import('sourcebuster')

  sbjs.init({
    domain: {
      host: window.location.hostname
        .replace('app.', '')
        .replace('www.', ''),
      isolate: false
    },
    lifetime: 15,
    session_length: 60
  })
}
